const skylines = [
  {
    name: 'Skyline Waspik',
    description: [
      'Minimalistische, 3D-geprinte skyline met herkenbare elementen zoals de St. Bartholomeuskerk en karakteristieke dorpssilhouetten.',
      'Perfect voor een persoonlijk cadeau, of een presentje voor jezelf. Verkrijgbaar in diverse kleuren.',
      'Ook een skyline van jouw eigen dorp of stad? Vraag gerust naar de mogelijkheden!'
    ],
    dimensions: '250x90x15mm',
    images: [
      require('../../images/skylines/Skyline_2A.jpg'),
      require('../../images/skylines/Skyline_2B.png'),
    ],
    stl: '/products/skylines/voorbeeld-skyline-2.stl',
    contactLink: '/contact?product=Skyline%20Waspik',
    price: '29,99',
  },
  {
    name: 'Skyline Geertruidenberg',
    description: [
      'Strakke, 3D-geprinte skyline met herkenbare elementen zoals de Geertruidskerk en het historische raadhuis.',
      'Perfect voor een persoonlijk cadeau, of een presentje voor jezelf. Verkrijgbaar in diverse kleuren.',
      'Ook een skyline van jouw eigen stad of dorp? Vraag gerust naar de mogelijkheden!'
    ],
    dimensions: '250x90x15mm',
    images: [
      require('../../images/skylines/Skyline_1A.png'),
      require('../../images/skylines/Skyline_1B.png'),
    ],
    stl: '/products/skylines/voorbeeld-skyline.stl',
    contactLink: '/contact?product=Skyline%20Geertruidenberg',
    price: '29,99',
  },
];

export default skylines; 